module.exports = __webpack_public_path__ + "static/RR_Front_Small-d0dfbbead76cf170f7362a9ff0fe97f0.png";